import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "config/site";
import { Rocket } from "lucide-react";

export const Logo = ({ className = "" }) => {
    return (
        <Link to="/" className={`flex items-center space-x-2 ${className}`}>
            <Rocket className="h-6 w-6" fill="currentColor" />

            <span className="font-bold">{siteConfig.name}</span>
        </Link>
    );
};
